<template>
    <button
        type="button"
        class="bk-ai-hint"
        :aria-label="$translate('Ceres::Template.imageAiHintLabel')"
        aria-controls="aside_ai-hint"
        @click.stop.prevent="openHint"
        @mousedown.stop
        @touchstart.stop
        @keydown.stop>
        <img
            class="bk-ai-hint__icon"
            src="https://cdn.bio-kinder.de/frontend/images/biokindertheme/icons/ai-info-w.svg"
            alt=""
            aria-hidden="true"
            width="66"
            height="17"
            decoding="async">
    </button>
</template>

<script>
export default {
    name: "ai-image-hint",

    methods: {
        openHint()
        {
            this.$root.$emit("toggle-aside", "ai-hint");
        }
    }
};
</script>
